// todo: refactor into smartIframeProvider

import { ApiConversionStateLookupType } from "@incendium/api";
import { createContext, useContext } from "react";

type IIFrameContext = {
  selectedSelector: string;
  selectedText: string;
  clearIframeSelection: () => void;
  productSchemaFound?: boolean;
  lookup?: ApiConversionStateLookupType;
};

export const IFrameContext = createContext<IIFrameContext | null>(null);
export const useIframeContext = () =>
  useContext(IFrameContext) as IIFrameContext;
